module.exports = __webpack_public_path__ + "static/02-f8184d5bf7bdc84b8b4c89877dfd3046.jpg";